/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Payment_DateInputs */

const vi_customer_debt_payment_date = /** @type {(inputs: Customer_Debt_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày`)
};

/**

* @param {Customer_Debt_Payment_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_payment_date = /** @type {((inputs?: Customer_Debt_Payment_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Payment_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_payment_date(inputs)
});